import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShare } from '@fortawesome/free-solid-svg-icons'

// Trigger for the v7 share modal. Routes through the openModal
// pipeline: a registered local handler at the donate-widget level
// (none in v7 — v7 always renders share as an iframe) would take
// precedence over the default renderModal; otherwise the dispatcher
// sends the openModal channel envelope upward, where the FLP
// registers `share:*` to open its own share dialog or the embed
// script falls through to renderModal at the top frame. See
// openModalTriggers.js for the data attribute contract.
const Share = ({ i18n, shareModal }) => (
  <button
    type="button"
    data-plg-modal-label={i18n.t('confirmation.share_button')}
    data-plg-modal-src={shareModal?.src}
    data-plg-modal-id={shareModal?.id}
    className="btn btn-primary inline-flex items-center justify-center gap-2"
  >
    <FontAwesomeIcon icon={faShare} />
    {i18n.t('confirmation.share_button')}
  </button>
)

export default Share
